var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.343,
    height: 35.962,
    viewBox: "0 0 30.343 35.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.278,1.928c-3.724,0-6.743,3.522-6.743,7.867,0,3.72,2.213,6.837,5.187,7.656l-1.116,18.2a2.093,2.093,0,0,0,2.11,2.243H10.84a2.093,2.093,0,0,0,2.11-2.243l-1.116-18.2c2.974-.819,5.187-3.936,5.187-7.656C17.021,5.45,14,1.928,10.278,1.928Zm22.664,0L31.068,13.166h-1.4L28.727,1.928H27.79l-.936,11.238h-1.4L23.576,1.928H22.64v14.61a1.124,1.124,0,0,0,1.124,1.124H26.69l-1.1,17.985A2.093,2.093,0,0,0,27.7,37.89h1.124a2.093,2.093,0,0,0,2.11-2.243l-1.1-17.985h2.927a1.124,1.124,0,0,0,1.124-1.124V1.928Z",
    transform: "translate(-3.535 -1.928)",
    fill: "#1c9d87"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFood);
export default __webpack_public_path__ + "static/media/Icon-food.961f14e13aee693ad9f8cb6fe644b935.svg";
export { ForwardRef as ReactComponent };